import vagasService from "@/service/vagasService";
import { usePagination } from "@/composables/usePagination";
import { ref } from "vue";

export function useVagas() {
  const vagas = ref([]);
  const vaga = ref(null);
  const isLoading = ref(false);
  const isSaving = ref(false);

  const pagination = usePagination({
    initialPage: 0,
    pageSize: 10,
    baseIndex: 0,
  });

  const fetchAllVagas = async (
    page = pagination.currentPage.value,
    size = pagination.pageSize.value
  ) => {
    isLoading.value = true;
    try {
      const response = await vagasService.getAllVagas(page, size);
      if (response && response.data) {
        vagas.value = response.data.content || response.data || [];
        pagination.setPaginationInfo(response.data);
        pagination.currentPage.value = page;
      }
      return response;
    } catch (error) {
      console.error("Erro ao buscar todas as vagas:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const fetchVagaById = async (vagaId) => {
    isLoading.value = true;
    try {
      const response = await vagasService.getVagaById(vagaId);
      vaga.value = response?.data || response;
      return response;
    } catch (error) {
      console.error(`Erro ao buscar vaga por ID (${vagaId}):`, error);
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  const fetchVagasFiltradas = async (filtros = {}) => {
    isLoading.value = true;
    try {
      const params = {
        page: pagination.currentPage.value,
        size: pagination.pageSize.value,
        ...filtros,
      };
      const response = await vagasService.getVagasFiltradas(params);
      if (response && response.data) {
        vagas.value = response.data.content || response.data || [];
        pagination.setPaginationInfo(response.data);
        pagination.currentPage.value = params.page;
      }
      return response;
    } catch (error) {
      console.error("Erro ao buscar vagas filtradas:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const saveVaga = async (acaoId, payload) => {
    isSaving.value = true;
    try {
      const response = await vagasService.postVaga(acaoId, payload);
      return response;
    } catch (error) {
      console.error("Erro ao criar vaga:", error);
    } finally {
      isSaving.value = false;
    }
  };

  const updateVaga = async (vagaId, payload) => {
    isSaving.value = true;
    try {
      const response = await vagasService.updateVaga(vagaId, payload);
      return response;
    } catch (error) {
      console.error("Erro ao atualizar vaga:", error);
    } finally {
      isSaving.value = false;
    }
  };

  const deleteVaga = async (vagaId) => {
    isLoading.value = true;
    try {
      const response = await vagasService.deleteVaga(vagaId);
      return response;
    } catch (error) {
      console.error("Erro ao deletar vaga:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const registrarCliqueInscricao = async (vagaId) => {
    try {
      const response = await vagasService.registrarCliqueInscricao(vagaId);
      return response;
    } catch (error) {
      console.error(
        `Erro ao registrar clique de inscrição (${vagaId}):`,
        error
      );
    }
  };

  const registrarVisualizacao = async (vagaId) => {
    try {
      const response = await vagasService.registrarVisualizacao(vagaId);
      return response;
    } catch (error) {
      console.error(`Erro ao registrar visualização (${vagaId}):`, error);
    }
  };

  return {
    vagas,
    vaga,
    isLoading,
    isLoadingVaga: isLoading,
    isSaving,
    isSavingVaga: isSaving,
    currentPage: pagination.currentPage,
    totalPages: pagination.totalPages,
    totalVagas: pagination.totalElements,
    pageSize: pagination.pageSize,
    hasNextPage: pagination.hasNextPage,
    hasPreviousPage: pagination.hasPreviousPage,
    fetchAllVagas,
    fetchVagaById,
    fetchVagasFiltradas,
    saveVaga,
    updateVaga,
    deleteVaga,
    registrarCliqueInscricao,
    registrarVisualizacao,
    nextPage: pagination.nextPage,
    previousPage: pagination.previousPage,
    goToPage: pagination.goToPage,
  };
}
